import { render, staticRenderFns } from "./OrderManagerCard.vue?vue&type=template&id=20cb5072&"
import script from "./OrderManagerCard.vue?vue&type=script&lang=js&"
export * from "./OrderManagerCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports